import BaseModel from '../../../models/base';

let queryPrefix = '?searchPath=';
if (window.location.search && window.location.search.indexOf('?') !== -1) {
    queryPrefix = `${window.location.search}&searchPath=`;
}

const query = queryPrefix + encodeURIComponent(window.location.pathname);

const RTLPreviewModel = BaseModel.extend({
    urlRoot() {
        const baseUrl = window.url(window.routes.rest.search.rtlPreview);

        return baseUrl + query;
    }
});

export default RTLPreviewModel;
